import { defineManifest } from "@crialume/sdk";
import { PenNibIcon } from "@crialume/ui/icons";

export default defineManifest({
  id: "studio",
  version: "0.1.0",
  meta: {
    name: "Studio",
    description: "Criação de moldes",
    icon: PenNibIcon,
    category: "core",
    order: 1,
  },
  requirements: {
    permissions: ["studio.author"],
  },
  nav: [{ label: "Moldes", path: "", icon: PenNibIcon }],
  fullscreenRoutes: [":moldId"],
  loader: () => import("./module"),
});
